export enum SmsServiceType {
  None = 0,
  DefaultRingCentral = 1,
  OwnRingCentral = 2,
  DedicatedRingCentral = 3,
  Twilio = 4,
  AgencyTwilio = 5,
  Spoke = 6,
  AgencySpoke = 7,
  AgencyOwnRingCentral = 8,
  GlobalTelecom = 9,
  AgencyGlobalTelecom = 10,
  PhoneGroup = 11,
}
